import {z} from 'zod';

export const layerTemplateSchema = z.object({
  id: z.string(),
  name: z.string(),
  modified: z.coerce.date(),
  isSegmented: z.boolean(), // bad name, should be isLinearlyDistributed
  sections: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .array(),
});

export const layerTemplatePayloadSchema = z.object({
  name: z.string().trim().min(2).max(30),
  isSegmented: z.boolean(),
  layoutId: z.string(),
  sections: z
    .object({
      type: z.enum(['term', 'numerical']),
      term: z
        .string()
        .array()
        .transform((terms) => terms.filter((term) => !!term.length)),
      numerical: z.object({
        low: z.coerce.number(),
        high: z.coerce.number(),
        interval: z.coerce.number(),
      }),
    })
    .check((ctx) => {
      if (ctx.value.type === 'numerical') {
        if (ctx.value.numerical.interval <= 0) {
          ctx.issues.push({
            code: 'custom',
            input: ctx.value.numerical,
            message: `Interval must be greater than 0.`,
          });
        }
        if (ctx.value.numerical.low >= ctx.value.numerical.high) {
          ctx.issues.push({
            code: 'custom',
            input: ctx.value.numerical,
            message: `Lower location bound cannot be greater or equal to higher location bound.`,
          });
        }
      } else {
        if (ctx.value.term.length < 1) {
          ctx.issues.push({
            code: 'too_small',
            input: ctx.value.term,
            origin: 'array',
            type: 'array',
            minimum: 1,
            inclusive: true,
            exact: false,
            message: 'At least 1 term must be provided.',
          });
        }
      }

      return z.NEVER;
    }),
});
